// extracted by mini-css-extract-plugin
export default {"mimicHixmeInputStyle":"ihuE6ujcqBhDnXbQQ6mt"};